import { StyleFunctionProps } from '@chakra-ui/react';
import { createBreakpoints, mode } from '@chakra-ui/theme-tools';
import { Dict } from '@chakra-ui/utils';
import defaultColors from './colors';
import { Alert } from './components/alert';
import { Button } from './components/button';
import { Checkbox } from './components/checkbox';
import { Input } from './components/input';
import { Modal } from './components/modal';
import { Select } from './components/select';
import { Text } from './components/text';
import { Tooltip } from './components/tooltip';
import defaultFonts from './fonts';
// 2. Update the breakpoints as key-value pairs
const breakpoints = createBreakpoints({
    sm: '320px',
    md: '768px',
    lg: '960px',
    xl: '1200px',
    '2xl': '1536px',
});

export default {
    partnerCode: 'mainline',
    initialColorMode: 'light',
    useSystemColorMode: false,
    components: {
        Button,
        Input,
        Select,
        Text,
        Modal,
        Tooltip,
        Checkbox,
        Alert,
    },
    styles: {
        global: (props: Dict<any> | StyleFunctionProps) => ({
            'html, body': {
                fontSize: 'md',
                bgColor: mode('light.pageBg', 'dark.pageBg')(props),
                height: 'auto',
                overflow: 'visible',
                lineHeight: 1.5,
                margin: 0,
            },
            '*, ::before, ::after': {
                boxSizing: 'border-box',
                borderWidth: '0',
                borderStyle: 'solid',
                // fontFamily: 'Roboto, sanserif',
            },
            a: {
                textDecoration: 'none',
                color: 'inherit',
            },
            'button  > svg': {
                width: '20px !important',
                height: '20px !important',
            },
            '.popover-text > ul': {
                'list-style-type': 'none',
                padding: 0,
                margin: 0,
            },
            '.popover-text > li': {
                'margin-bottom': '6px',
            },
            '#datePickerMonth, #datePickerYear': {
                color: 'brand.10',
            },
        }),
    },
    breakpoints,
    colors: defaultColors,
    fonts: defaultFonts,
    fontSizes: {
        xs: '12px',
        sm: '13px',
        md: '13px',
        lg: '16px',
        xl: '18px',
        '2xl': '24px',
        '3xl': '28px',
        '4xl': '36px',
        '5xl': '48px',
        '6xl': '64px',
    },
    zIndices: {
        tooltip: 9999,
    },
};
